export const LOCAL_STORAGE_KEY = "miracle";
export const localStorageUserKey = `${LOCAL_STORAGE_KEY}/user`;
